module.exports = __webpack_public_path__ + "mobile/img/icon_wechat.bf97c65e.png";